import { setupInterceptors } from './interceptors';
import { setApiDefaults } from './defaultSettings';

export const initApi = store => {
  setApiDefaults();
  setupInterceptors(store)
};
